export const COUNTER_ABI = ['function get() public view returns (uint)', 'function inc() public']

export const ipfsUrl = 'https://ipfs.infura.io/ipfs/'